import React from "react";
import { useNavigate } from "react-router-dom";

export const Dashboard = () => {
  const navigate = useNavigate();
  React.useEffect(() => {
    navigate("/admin/orders");
  }, []);
  return <div style={{ minHeight: "80vh" }}>Admin</div>;
};
